/* eslint-disable no-console */
import {AxiosRequestConfig} from 'axios';
import {Analytics, SlidesTopTimeAnalyticsDTO} from '../incase-domain/analytics';
import {httpDelete, httpGet} from './http.service';
import {TimeSpentOnSlideDTO} from '../incase-domain/proptypes/slidesAnalytics';

export const fetchPresAnalytics = (
    presentationId: string,
    queryParams?: Record<string, string | undefined>,
    config?: AxiosRequestConfig
): Promise<Analytics> => {
    const query = new URLSearchParams();

    Object.entries(queryParams || {}).forEach(([key, value]) => {
        if (value != null) {
            query.append(key, value);
        }
    });

    const queryString = query.toString();
    const url = `admin/analytics/${presentationId}${queryString ? `?${queryString}` : ''}`;

    return httpGet(url, config);
};

export const fetchPresSlidesTopTimeAnalytics = (
    presentationId: string,
    params?: {from?: string; to?: string}
): Promise<SlidesTopTimeAnalyticsDTO | undefined> => {
    const query = new URLSearchParams();
    if (params?.from) query.append('from', params.from);
    if (params?.to) query.append('to', params.to);

    const queryString = query.toString();
    const url = `admin/analytics/slidesTopTimeAnalytics/${presentationId}${queryString ? `?${queryString}` : ''}`;

    return httpGet(url).catch((error) => {
        console.log(error);
    });
};

export const fetchMostViewedSlidesAnalytics = (
    presentationId: string,
    topSlides: number,
    queryParams?: Record<string, string | undefined>,
    config?: AxiosRequestConfig
): Promise<TimeSpentOnSlideDTO[]> => {
    const query = new URLSearchParams();

    Object.entries(queryParams || {}).forEach(([key, value]) => {
        if (value != null) {
            query.append(key, value);
        }
    });

    const queryString = query.toString();
    const url = `admin/analytics/mostViewSlidesAnalytics/${presentationId}/${topSlides}${queryString ? `?${queryString}` : ''}`;

    return httpGet(url, config);
};

export const resetPresAnalytics = (presentationId: string): Promise<{success: boolean}> => {
    return httpDelete(`admin/analytics/reset/${presentationId}`, {})
        .then(() => {
            return {success: true};
        })
        .catch((error) => {
            console.log(error);
            return {success: false};
        });
};

export const invalidateAnalyticsCache = (presentationId: string): Promise<{success: boolean}> => {
    return httpDelete(`admin/analytics/invalidate/${presentationId}`, {})
        .then(() => {
            return {success: true};
        })
        .catch((error) => {
            console.log(error);
            return {success: false};
        });
};
